import React, { useEffect, useRef } from 'react';

const SCRIPT_ID = 'google-maps-places-script';

function loadGoogleMapsScript(apiKey) {
    if (document.getElementById(SCRIPT_ID)) return;
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    document.head.appendChild(script);
}

const PlacesAutocomplete = ({ value, onChange, placeholder, className }) => {
    const inputRef = useRef(null);
    const autocompleteRef = useRef(null);
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;

    useEffect(() => {
        if (!apiKey) return;

        const init = () => {
            if (!inputRef.current || !window.google?.maps?.places) return;
            if (autocompleteRef.current) return;

            autocompleteRef.current = new window.google.maps.places.Autocomplete(
                inputRef.current,
                { types: ['establishment', 'geocode'] }
            );

            autocompleteRef.current.addListener('place_changed', () => {
                const place = autocompleteRef.current.getPlace();
                if (place?.formatted_address) {
                    onChange(place.formatted_address);
                } else if (inputRef.current) {
                    onChange(inputRef.current.value);
                }
            });
        };

        if (window.google?.maps?.places) {
            init();
        } else {
            loadGoogleMapsScript(apiKey);
            // Poll until the script loads
            const interval = setInterval(() => {
                if (window.google?.maps?.places) {
                    clearInterval(interval);
                    init();
                }
            }, 200);
            return () => clearInterval(interval);
        }
    }, [apiKey, onChange]);

    return (
        <input
            ref={inputRef}
            type="text"
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder || 'Address or location name'}
            className={className}
            autoComplete="off"
        />
    );
};

export default PlacesAutocomplete;
